// src/components/patient/common/ListPagination.jsx
//
// Server-driven pagination footer: rows-per-page selector, First / Previous /
// page number / Next / Last and "Showing page X of Y · N total <noun>".
// Page and total come from the server response only.

import React from "react";

import { classNames } from "../booking/bookingUi";

const BUTTON = "rounded-xl border border-border bg-white px-3 py-1.5 text-sm font-semibold text-text hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50";

export default function ListPagination({ page, totalPages, total, pageSize, pageSizes = [10, 20, 50], noun = "total", disabled = false, onPage, onPageSize, idPrefix = "list" }) {
  const pages = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(Math.max(1, Number(page) || 1), pages);
  const atStart = current <= 1;
  const atEnd = current >= pages;

  return (
    <div className="mt-4 flex flex-col gap-3 border-t border-border pt-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-wrap items-center gap-3 text-sm text-muted">
        <label htmlFor={`${idPrefix}-page-size`} className="font-semibold text-text">Rows:</label>
        <select id={`${idPrefix}-page-size`} value={pageSize} disabled={disabled} onChange={(e) => onPageSize(Number(e.target.value))}
          className="rounded-xl border border-border bg-white px-2 py-1.5 text-sm">
          {pageSizes.map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
        <span data-testid={`${idPrefix}-pagination-summary`} aria-live="polite">
          Showing page {current} of {pages} · {Number(total) || 0} {noun}
        </span>
      </div>
      <nav aria-label="Pagination" className="flex flex-wrap items-center gap-1.5">
        <button type="button" className={BUTTON} disabled={disabled || atStart} onClick={() => onPage(1)}>First</button>
        <button type="button" className={BUTTON} disabled={disabled || atStart} onClick={() => onPage(current - 1)}>Previous</button>
        <span aria-current="page" className={classNames("min-w-[2.25rem] rounded-xl bg-primary px-3 py-1.5 text-center text-sm font-semibold text-white")}>{current}</span>
        <button type="button" className={BUTTON} disabled={disabled || atEnd} onClick={() => onPage(current + 1)}>Next</button>
        <button type="button" className={BUTTON} disabled={disabled || atEnd} onClick={() => onPage(pages)}>Last</button>
      </nav>
    </div>
  );
}
